import { keyframes, styled } from "../../../../../../styles/tokens";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const Overlay = styled("div", {
  position: "fixed",
  inset: 0,
  zIndex: 3100,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  background: "rgba(0, 0, 0, 0.2)",
});

export const Card = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "20px",

  padding: "24px 32px",

  background: "$white",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
});

export const Spinner = styled("div", {
  width: "28px",
  height: "28px",

  borderRadius: "50%",
  border: "3px solid $gray-30",
  borderTopColor: "var(--colors-portal-loading-state-color)",

  animation: `${spin} 0.8s linear infinite`,
});

export const Message = styled("span", {
  fontFamily: "$openSans",
  fontWeight: 400,
  fontSize: "$text-md",
  lineHeight: "20px",
  color: "$charcoal",
});
